export const SET_CONFIG = "SET_CONFIG";
export const SET_CONTENU = "SET_CONTENU";
